import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconSearchLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.963 16.922c-1.944 0-3.591-.674-4.94-2.022C3.674 13.55 3 11.905 3 9.96s.674-3.59 2.023-4.939C6.372 3.674 8.02 3 9.963 3c1.945 0 3.591.674 4.94 2.022 1.349 1.349 2.023 2.995 2.023 4.939 0 .813-.136 1.59-.41 2.33a6.51 6.51 0 0 1-1.092 1.93l5.334 5.332a.824.824 0 0 1 .242.594.805.805 0 0 1-.242.606.817.817 0 0 1-.6.247.817.817 0 0 1-.6-.247l-5.334-5.333c-.57.47-1.224.838-1.964 1.104a6.75 6.75 0 0 1-2.297.398Zm0-1.707c1.467 0 2.71-.51 3.728-1.527 1.018-1.018 1.527-2.26 1.527-3.727s-.509-2.709-1.527-3.727c-1.018-1.018-2.26-1.527-3.728-1.527-1.467 0-2.71.51-3.728 1.527-1.018 1.018-1.527 2.26-1.527 3.727s.509 2.709 1.527 3.727c1.018 1.018 2.26 1.527 3.728 1.527Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconSearchLine;
